/* esm.sh - @noble/hashes@2.0.1/_u64 */
export * from "/*@noble/hashes@2.0.1/esnext/_u64.mjs";
export { default } from "/*@noble/hashes@2.0.1/esnext/_u64.mjs";
